// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { StorageEnum } from './enums/storage.enum';
import { StorageService } from './services/storage.service';
import { inject, PLATFORM_ID } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from './services/auth.service';
import { ErrorService } from './services/error.service';
import { UtilService } from './services/util.service';

export const authtokenheaderInterceptor: HttpInterceptorFn = (req, next) => {
  const authS = inject(AuthService);
  const storage = inject(StorageService);
  const platformId = inject(PLATFORM_ID);
  const errorS = inject(ErrorService);
  const utilS = inject(UtilService);

  const acct = storage.getSession(StorageEnum.LoginResponse) ?? storage.getSession(StorageEnum.MultiAccountResponse);
  const acctLookUp = storage.getSession(StorageEnum.AccountLookUp);
  const endPointToAddAuthHeaderTo = environment.OASUrl();
  const preAuthEndpoints = ['/GSMobile/RegisterMobileDevice'];
  const isBrowser = isPlatformBrowser(platformId);

  let authToken = acct?.AuthToken;
  if (!authToken) {
    authToken = acctLookUp?.AuthToken;
  }
  const isPreAuthEndpoint = preAuthEndpoints.some((endpoint) => req.url.includes(endpoint));
  if (req.url.includes(endPointToAddAuthHeaderTo) && !req.url.includes('unauth') && !isPreAuthEndpoint) {
    if (authToken) {
      const clonedReq = req.clone({
        headers: req.headers.set('authtoken', authToken),
      });
      return next(clonedReq).pipe(
        // https://javascript.plainenglish.io/adopting-a-functional-approach-for-http-interceptors-in-angular-c5109d87f2b2
        // catch no valid token error and redirect to log in
        catchError((error: HttpErrorResponse) => {
          utilS.consoleLog(error);
          if (error.status === 500 || error.status === 408) {
            errorS.goToTechnicalError();
            return throwError(() => new Error('Technical Error'));
          } else {
            authS.logout();
            return throwError(() => new Error('Unauthorized'));
          }
        }),
      );
    } else {
      if (isBrowser) {
        authS.logout();
        return throwError(() => new Error('Unauthorized'));
      }
    }
  }
  return next(req);
};
